import { useAchievementTypes, useReduxState } from 'hooks';
import { Icon } from 'components/common/icons';

import type { Achievement } from 'shared-types';

interface Props {
  size?: 'small' | 'medium' | 'large';
  type: Achievement['type'];
}

const AchievementIcon = ({ size = 'medium', type }: Props) => {
  const { theme } = useReduxState();

  const achievementTypes = useAchievementTypes();

  const backgroundColor = achievementTypes[type].backgroundColor;
  const color = achievementTypes[type].color;
  const icon = achievementTypes[type].icon;

  return (
    <div className={`icon icon-${size}`}>
      <div className="icon-header" style={{ backgroundColor }}>
        <div className="icon-header-content" style={{ color }}>
          <Icon icon={icon} />
        </div>
      </div>
      <div className="icon-footer">
        <div className="icon-footer-left" style={{ backgroundColor }} />
        <div className="icon-footer-right" style={{ backgroundColor }} />
      </div>

      <style jsx>{`
        .icon {
          display: inline-block;
          flex-grow: 0;
          flex-shrink: 0;
          height: 50px;
          overflow: hidden;
          position: relative;
        }
        .icon-header {
          border-radius: 8px 8px 0 0;
          padding: 1px 5px 5px;
        }
        .icon-header-content {
          background-color: ${theme.lightGrey};
          background-color: white;
          border-radius: 40px;
          display: inline-block;
          flex-shrink: 0;
          font-size: 1.5rem;
          margin-top: 5px;
          padding: 5px 0;
          text-align: center;
          height: 28px;
          width: 28px;
        }
        .icon-footer {
          background-color: transparent;
          border-radius: 5px;
          position: relative;
          top: -5px;
          height: 21px;
          width: 100%;
          overflow: hidden;
        }
        .icon-footer-left,
        .icon-footer-right {
          border-radius: 5px;
          content: '';
          bottom: 15px;
          position: absolute;
          height: 45px;
          width: 100%;
        }
        .icon-footer-left {
          left: 0px;
          transform: skewY(-25deg);
        }
        .icon-footer-right {
          right: 0px;
          transform: skewY(25deg);
        }
        .icon-small {
          height: 42px;
        }
        .icon-small .icon-header {
          border-radius: 7px 7px 0 0;
          padding: 0px 4px 4px;
        }
        .icon-small .icon-header-content {
          font-size: 1.2rem;
          padding: 6px 0;
          height: 24px;
          width: 24px;
        }
        .icon-small .icon-footer {
          height: 20px;
          top: -4px;
        }
        .icon-large {
          height: 68px;
        }
        .icon-large .icon-header {
          border-radius: 10px 10px 0 0;
          padding: 3px 8px 5px;
        }
        .icon-large .icon-header-content {
          font-size: 1.8rem;
          padding: 7px 0;
          height: 36px;
          width: 36px;
        }
        .icon-large .icon-footer {
          height: 25px;
        }
      `}</style>
    </div>
  );
};

export default AchievementIcon;
